import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const getFormUrl = () => {
    const path = window.location.pathname;
    const base = path
        .replace(/\/detail\/?$/, '')
        .replace(/\/list\/?$/, '')
        .replace(/\/form\/?$/, '')
        .replace(/\/$/, '');
    return `${window.location.origin}${base}/form`;
};

const renderDescWithBr = (text) =>
    text.split(/<br\s*\/?>/i).map((part, i) => (
        <React.Fragment key={i}>
            {i > 0 && <br />}
            {part}
        </React.Fragment>
    ));

const PageHeader = ({ showFormEntry = false, desc = null, variant = 'banner', setFixedRightVal }) => {
    const isBanner = variant === 'banner';
    const headerRef = useRef(null);
    const [formEntryRight, setFormEntryRight] = useState(() => {
        if (typeof window === 'undefined') {
            return 0;
        }
        const viewportWidth = window.innerWidth;
        const headerWidth = headerRef.current?.getBoundingClientRect()?.width || viewportWidth;
        const value = Math.max((viewportWidth - headerWidth) / 2, 0);

        if (setFixedRightVal) {
            setFixedRightVal(value);
        }

        return value;
    });

    useEffect(() => {
        const updateRight = () => {
            const viewportWidth = window.innerWidth;
            const headerWidth = headerRef.current?.getBoundingClientRect()?.width || viewportWidth;
            const value = Math.max((viewportWidth - headerWidth) / 2, 0);
            
            if (setFixedRightVal) {
                setFixedRightVal(value);
            }
            setFormEntryRight(value);
        };
        updateRight();
        window.addEventListener('resize', updateRight);

        return () => window.removeEventListener('resize', updateRight);
    }, []);

    return (
        <header ref={headerRef} className={`${styles.header} ${isBanner ? styles.banner : styles.inline}`}>
            <div className={styles.headerRow}>
                <img className={styles.headerRowPic} src="https://x0.ifengimg.com/ucms/2026_11/59A8214D270CA5490DDEDD58446206FAE8CD6BDA_size211_w2276_h1279.jpg" alt="" />
                {/* <h1 className={styles.title}>凤凰投诉</h1> */}
                {showFormEntry && (
                    <a href={getFormUrl()} className={styles.formEntry} style={{ right: `${formEntryRight + 20}px` }}>
                        投诉
                    </a>
                )}
            </div>
            {/* {desc && <p className={styles.desc}>{typeof desc === 'string' && desc.includes('<br') ? renderDescWithBr(desc) : desc}</p>} */}
        </header>
    );
};

PageHeader.propTypes = {
    showFormEntry: PropTypes.bool,
    desc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    variant: PropTypes.oneOf(['banner', 'inline']),
    setFixedRightVal: PropTypes.func
};

export default PageHeader;
